import ChapterProgression from "../../../apis/academic/chapterProgression.js";
export default {
  namespaced: true,

  state() {
    return {
        resources: {
          data: [],
          current_page: 0,
          last_page: 1,
          total: 0,
        },

      //   allResources: [],

      // showResource: null,

        keys: {
          resources: {
            localStorageName: "ChapterProgression",
          },
        },

      //   filters: {
      //     SubjectTeacher_group_id: null,
      //     standard_id: null,
      //   },
    };
  },

  getters: {
    resourcesKey(state) {
      return state.keys.resources;
    },
    resources(state) {
      return state.resources;
    },
    // filters(state) {
    //   return state.filters;
    // },
    // allResources(state){
    //   return state.allResources;
    // },
    // showResource(state) {
    //   return state.showResource;
    // },
    nextResourcesPage(_, getters) {
      const resources = getters.resources;
      const current_page = resources.current_page;
      const last_page = resources.last_page;
      return last_page > current_page ? current_page + 1 : false;
    },
  },

  mutations: {
    resources(state, payLoad) {
      if (payLoad.refresh) {
        state.resources.data = payLoad.response.data;
      } else {
        state.resources.data.push(...payLoad.response.data);
      }
      state.resources.current_page = payLoad.response.current_page;
      state.resources.last_page = payLoad.response.last_page;
      state.resources.total = payLoad.response.total;
      localStorage.setItem(payLoad.key, JSON.stringify(state.resources));
    },
    // filters(state, payLoad) {
    //   state.filters = payLoad;
    // },
    // allResources(state, payLoad){
    //   state.allResources = payLoad;
    // }
    // showResource(state, payLoad) {
    //   state.showResource = payLoad;
    // },
  },

  actions: {
    async resources(context, payLoad) {
      const refresh = payLoad.refresh ? true : false;
      const key = context.getters.resourcesKey;
      //   const filters = context.getters.filters;
      const resourceId = payLoad.resourceId;
      const inLocalStorage = refresh
        ? null
        : await JSON.parse(localStorage.getItem(key.localStorageName));

      if (inLocalStorage) {
        context.state.resources = inLocalStorage;
      }

      const nextResourcesPage = refresh ? 1 : context.getters.nextResourcesPage;

      if (nextResourcesPage) {
        //  const response = await ImportedApi.index(page)
        const response = await ChapterProgression.index(
          nextResourcesPage,
          resourceId
        );

        const dispatch = {
          response: response.data,
          refresh: refresh,
          key: key.localStorageName,
        };
        context.commit("resources", dispatch);
      }
    },

    async createResource(context, payLoad) {
      // const response = await ImportedApi.create(resource_id)
      await ChapterProgression.create(payLoad);
      context.dispatch("resources", { refresh: true, resourceId: payLoad.chapter_id });
    },

    // async showResource(context, payLoad) {
    //   const showResource = await ChapterProgression.show(payLoad.resourceId);
    //   context.commit("showResource", showResource.data);
    // },

    async updateResource(_, payLoad) {
      // const response = await ImportedApi.update(resource_id, data)
      const data = payLoad;
      await ChapterProgression.update(payLoad.id, data);
      //   context.dispatch("resources", { refresh: true, resourceId: payLoad.subject_id });
    },

    // async deleteResource(context, payLoad) {
    //   // const response = await ImportedApi.delete(resource_id)
    //   await Chapter.delete(payLoad.resourceId);
    //   context.dispatch("resources", { refresh: true, resourceId: payLoad.subjectId });
    // },

    // async filters(context, payLoad) {
    //   await context.commit("filters", payLoad);
    //   context.dispatch("resources", { refresh: true });
    // },

    // async allResources(context){
    //   // All resources without pagination
    //   const allResources = await Chapter.all();
    //   context.commit("allResources", allResources.data)
    // }
  },
};
